import { CatCarousel } from 'components/blocks-components';
import styles from './product-card-carousel.module.scss'

export const ProductCardCarousel = ({ children }) => {
  return (
    <CatCarousel
      activeIndex={0}
      hideSlideCount
      behavior="slideShow"
      navigation="external"
      navigationMode="dark"
      navigationSize="sm"
      className={styles['carousel-changes']}
    >
      {children}
    </CatCarousel>
  );
};